import clsx from "clsx"
import SuraasaPlusLogo, {
  LogoVariant,
} from "features/SuraasaPlus/components/SuraasaPlusLogo"

export enum PlusBadgeSize {
  xs = "xs",
  small = "sm",
  medium = "md",
  large = "lg",
}

type SuraasaPlusBadgeProps = {
  size?: PlusBadgeSize
  className?: string
}

const SuraasaPlusBadge = ({
  size = PlusBadgeSize.medium,
  className,
}: SuraasaPlusBadgeProps) => {
  const logoSizes = {
    [PlusBadgeSize.xs]: { height: 6, width: 12 },
    [PlusBadgeSize.small]: { height: 9, width: 18 },
    [PlusBadgeSize.medium]: { height: 13, width: 26 },
    [PlusBadgeSize.large]: { height: 15, width: 31 },
  }

  return (
    <div
      className={clsx(
        "pointer-events-none flex w-fit shrink-0 items-center justify-center",
        "bg-[linear-gradient(90deg,#C38AFE_0%,#4DD9F4_35%,#ADE65D_65%,#F0E05C_82.25%,#FAA13C_100%)]",
        {
          "rounded-[2px] p-[0.5px]": size === PlusBadgeSize.xs,
          "rounded-[4px] p-[0.97px]": size === PlusBadgeSize.small,
          "rounded-[5px] py-[1.5px] pl-[1.37px] pr-[1.5px]":
            size === PlusBadgeSize.medium,
          "rounded-[7px] p-[1.65px] pl-[1.5px] pt-[1.5px]":
            size === PlusBadgeSize.large,
        },
        className
      )}
    >
      <div
        className={clsx(
          "flex items-center justify-center",
          "bg-[linear-gradient(90deg,#E6EEF9_0%,#FFFFFF_50.96%,#E6EEF9_100%)]",
          {
            "h-[9px] w-[16px] rounded-[2px] pb-[1px] pl-[2px] pr-[1px]":
              size === PlusBadgeSize.xs,
            "h-[13px] w-[23px] rounded-[3px] pb-[2px] pl-[3px] pr-0.25":
              size === PlusBadgeSize.small,
            "h-[18px] w-[32px] rounded-[4px] pb-[2px] pl-[5px] pr-[3px]":
              size === PlusBadgeSize.medium,
            "h-[22.5px] w-[42px] rounded-[6px] pl-0.5 pr-0.25":
              size === PlusBadgeSize.large,
          }
        )}
      >
        <SuraasaPlusLogo
          variant={LogoVariant.plus}
          color="#1E3759"
          height={logoSizes[size].height}
          width={logoSizes[size].width}
        />
      </div>
    </div>
  )
}

export default SuraasaPlusBadge
